export enum ContainerLevel {
  Producto,
  Etapa,
  Requisito,
  Tarea
}
